<template>
  <div class="imageModal" v-if="show">
    <button @click="closeModal()" class="imageModal__Overlay"></button>
    <div class="imageModal__Content">
      <button @click="closeModal()" class="imageModal__Close">
        <icon name="times"></icon>
      </button>
      <image-upload label="Upload image into post" :required="true" v-model="imageSrc"></image-upload>
      <button class="button" @click="insertImage">Insert image</button>
    </div>
  </div>
</template>

<script>
import ImageUpload from '@/components/editor/ImageUpload.vue'

export default {
  components: { ImageUpload },
  data() {
    return {
      imageSrc: null,
      command: null,
      show: false,
    }
  },
  methods: {
    insertImage() {
      const data = {
        command: this.command,
        data: {
          src: this.imageSrc.original,
        },
      }

      this.$emit('onConfirm', data)
      this.closeModal()
    },
    showModal(command) {
      // Add the sent command
      this.command = command
      this.show = true
    },
    closeModal() {
      this.show = false
      this.imageSrc = ''
    },
  },
}
</script>

<style lang="scss">
.imageModal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 3000;
}

.imageModal__Overlay {
  all: unset;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.imageModal__Content {
  padding: 30px;
  background: white;
  width: 100%;
  max-width: 500px;
  position: relative;
}

.imageModal__Close {
  all: unset;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }

  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
